import { UserService } from '@nuskin/ns-account'
const isProd = process.env.NODE_ENV === 'production'

export const MySiteError = {
    /**
   * @param {Error} err - try..catch error object
   * @param {String} message - custom error message
   * @param {Function} callback - callback function
   */
    handle: (err, message, callback) => {
        message = message || err.message
        // TODO: handle any error, not just 'no connection' (ex. show an error message to the user)

        // call a callback function
        if (callback && typeof callback === 'function') callback()

        console.error(err)
        // if in prod mode, then handle them by logging errors straight to newrelic
        if (isProd) {
            try {
                // eslint-disable-next-line no-undef
                newrelic.noticeError(err, {
                    environment: process.env.NODE_ENV,
                    hash: window.location.href,
                    message,
                    distId: UserService.getUser().id
                })
            } catch (er) {
                console.log('ERROR: New Relic Browser Agent is not available!')
                console.log('NEWRELIC ERROR: ', er.message)
            }
        }

        setTimeout(() => {
            throw new Error(message)
        })
    }
}
